import React from 'react';

import StatsWrapper from 'components/Stats/StatsWrapper';
import NavPills from "components/NavPills/NavPills.jsx";

import PerDayChart from './GPTabs/PerDayChart';
import HourlyAverage from './GPTabs/HourlyAverageChart';
import TotalCostPriceChart from './GPTabs/TotalCostPriceChart';
import TotalCostPriceTable from './GPTabs/TotalCostPriceTable';

export default class GPTab extends React.Component {
    render() {        
        const id = this.props.customer_id + "-" + this.props.product_id;

        return (
            <NavPills
                swipeableSlideStyles={{ padding: 20 }}
                color="success"
                tabs={[
                    {
                        tabButton: "Per Day",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="dailyGP" post params={{ customer_id: this.props.customer_id, product_id: this.props.product_id }}>
                                <PerDayChart />
                            </StatsWrapper>
                        )
                    },
                    {
                        tabButton: "Hourly Average",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="hourlyAverage" post params={{ customer_id: this.props.customer_id, product_id: this.props.product_id }}>
                                <HourlyAverage />
                            </StatsWrapper>
                        )
                    },
                    {
                        tabButton: "Cost/Price Comparison",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="totalCostsAndPrices" post params={{ customer_id: this.props.customer_id, product_id: this.props.product_id }}>
                                <TotalCostPriceChart />
                                <TotalCostPriceTable />
                            </StatsWrapper>
                        )
                    }
                ]}
            />
        );
    }
}